import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/shared/Services/api.service';
import { ApiPaths } from 'src/app/shared/Models/api-path';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private apiService: ApiService) {}

  RegisterUser(data: any) {
    const localurl = ApiPaths.employee.addUpdate;
    return this.apiService.post(localurl, data);
  }

  GetUserSetup(costCenterId:any,businessUnitId:any,showLoader:boolean) {
    const ManagerVM = {
      CCId: costCenterId,
      BUId: businessUnitId,
    }
    const localurl = ApiPaths.employee.loadManagerList;
    return this.apiService.post(localurl,ManagerVM,showLoader);
  }

  GetUserList = (searchVm : any) => {
    const localurl =
      ApiPaths.employee.getListBySearch;
    return this.apiService.post(localurl,searchVm);
  };

  DeleteUser(UserId: number): Observable<any> {
    const deleteVM = {
      Id : UserId
    }
    const localurl = ApiPaths.employee.delete;
    return this.apiService.post(localurl,deleteVM);
  }
  getEmployeeByID(UserId: number): Observable<any> {
    const localurl = ApiPaths.employee.getById(UserId);
    return this.apiService.get(localurl);
  }

  getUserByID(UserId: number): Observable<any> {
    const localurl = ApiPaths.employee.loadUserData(UserId);
    return this.apiService.get(localurl);
  }

  resetPassword(emailId: any) {
    const localurl = `SignUp/ForgetPass`;
    const data = {emailId : emailId};
    return this.apiService.post(localurl,data);
  }

  changeStatusActiveInactive(userid:number,status:boolean) {
    const localurl = ApiPaths.employee.UpdateStatus;
    let body = {
      "Id":userid,
      "Status": status,
    }
    return this.apiService.post(localurl,body);
  }
}
